module.exports = __webpack_public_path__ + "img/gatopc.717bfe17.webp";